<template lang="pug">
  div.c-wrapper
    .speaker(v-for='item in val' :key='item.id')
      div.speaker__container(v-for='target in speakerItem(item)' :key='target.id')
        .speaker__wrapper(:id='target.speakerID')
          .speaker__photo(v-if='target.photo')
            img(:src='target.photo')
          .speaker__detail
            p.speaker__moderator(v-if='target.moderator') [モデレーター]
            h5.speaker__company {{target.company}}
            ul.speaker__position
              li(v-for='(pos, key) in target.position' :key='key') {{pos}}
            h4(v-if='target.host || target.id == 99') {{target.name1}}
            h4(v-else) {{target.name1}} <span>氏</span>
            p(v-if='target.name2') {{target.name2}}
        .speaker__profile(v-if="prof && target.profile != ''")
          h4 [プロフィール]
          p(v-for='(profile, key) in target.profile' :key='key') {{profile}}
</template>

<script>
import items from "@/assets/speaker.json";

export default {
  name: "Speaker",
  props: {
    val: {},
    val2: {},
    opt: {},
    prof: {},
    sessId: {},
  },
  data() {
    return {
      items: items
    };
  },
  methods: {
    speakerItem(speakerId) {
      const target = this.items.filter(({ id }) => id === speakerId);
      return target;
    }
  }
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";
.c-wrapper {
  margin: 0;
  padding: 0;

  @media screen and (min-width: 769px) {
    display: flex;
    flex-wrap: wrap;
  }
}

.speaker {
  margin-top: 30px;
  width: 100%;

  @media screen and (max-width: 768px) {
    &:first-child {
      margin-top: 0;
    }
  }
}

#speaker_03,
#speaker_04{
  .speaker__position {
    margin-top: 0;
    li:nth-child(odd) {
      font-size: 12px;
      color: #444;
    }
    li:nth-child(even) {
      margin-top: 2px;
    }
    li:nth-child(3) {
      margin-top: 5px;
    }
  }
}

@media screen and (min-width: 769px) {
  .speaker {
    max-width: 100%;
    flex-basis: 50%;
    flex-grow: 1;
  }
}

@media screen and (min-width: 769px) {
  .modal .speaker {
    flex-basis: auto;
  }
}

.overlay .speaker {
  width: 100%;
  padding-top: 30px;
  border-top: 1px solid #ddd;
}

.overlay .speaker:first-child {
  margin-top: 10px;
}

.speaker__wrapper {
  display: block;
  text-align: center;
}

@media screen and (min-width: 480px) {
  .speaker__wrapper {
    display: flex;
    align-items: center;
    text-align: left;
  }
}

.speaker__sub {
  margin: 0 15px 10px;
  font-size: 12px;
  padding: 2px 10px;
  color: #fff;
  background-color: #3b90bb;
  display: inline-block;
}

.speaker__photo,
.speaker__detail {
  margin: 0 0 0 15px;
}

.speaker__photo img {
  display: block;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin: auto;
  border: 1px solid #ddd;
}

@media screen and (min-width: 480px) {
  .speaker__wrapper {
    margin: 0;
  }
}

.speaker__detail p {
  margin: 0;
  font-weight: 600;
  font-size: 14px;
}

.speaker__detail h4 {
  margin: 0;
  font-size: 14px;
}

.speaker__detail h4 span {
  font-size: 12px;
}

.speaker__detail h4 + p {
  font-weight: 200;
  color: #999;
  font-size: 12px;
}

.speaker__company {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: #444;
}

.speaker__position {
  list-style: none;
  padding: 0;
  margin: 2px 0 10px;
  font-size: 12px;
  color: #888;
}

.speaker__profile {
  font-size: 14px;
  margin: 0 15px;
}

p.speaker__moderator {
  color: $tertiary-color06;
  font-size: 12px;
  margin-bottom: 3px;
}

.modal .speaker__container {
  margin: 0 -15px;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;

  .speaker__wrapper,
  .speaker__profile {
    flex-basis: 100%;
  }

  .speaker__wrapper {
    @media screen and (min-width: 767px) {
      flex-basis: 40%;
    }
  }
  .speaker__profile {
    margin-top: 2rem;

    @media screen and (min-width: 767px) {
      flex-basis: 55%;
      margin-top: 0;
    }
  }

  .speaker__profile {
    h4 {
      margin: 0;

      & + p {
        margin-top: .5rem;
      }
    }
  }
}
</style>